import { gsap } from 'gsap';
import focusLock from 'dom-focus-lock';
import { getScrollbarWidth } from '../function/getScrollBarWidth';
import { closeNavigation } from './menu';

const search: HTMLElement = document.getElementById('header-search');
const searchButton: HTMLElement = document.getElementById('header-search-button');
const header: HTMLElement = document.getElementById('header');
const openSearch: HTMLElement = document.getElementById('openSearch');
const exitSearch: HTMLElement = document.getElementById('exitSearch');
export const closeHeaderSearch = function () {
    searchButton.classList.remove('close-button-underline');
    searchButton.classList.add('open-button-underline');
    exitSearch.style.display = 'none';
    openSearch.style.display = 'block';
    gsap.to(search, {
        duration: 0, // Set duration to 0 for instant animation
        y: '-100px', // Start 100px down
        transformOrigin: 'top',
        ease: 'expo.inOut',
        onComplete: () => {
            search.classList.remove('search--open');
            searchButton.setAttribute('aria-expanded', 'false');
            header.classList.remove('elevate');
            focusLock.off(search);
            search.removeEventListener('keyup', escapeEvent);
            document.body.classList.remove('no-scroll');
            searchButton.focus();
        },
    });
};

const escapeEvent = (event) => {
    if (event.defaultPrevented) {
        return;
    }
    const key = event.key || event.keyCode;

    if (key === 'Escape' || key === 'Esc' || key === 27) {
        closeHeaderSearch();
    }
};

(function () {
    const body: HTMLElement = document.body;

    if ('undefined' === typeof searchButton || !search) {
        return;
    }

    searchButton.onclick = function () {
        if (search.classList.contains('search--open')) {
            closeHeaderSearch();
        } else {
            closeNavigation();
            searchButton.classList.remove('open-button-underline');
            searchButton.classList.add('close-button-underline');
            exitSearch.style.display = 'block';
            openSearch.style.display = 'none';
            const scrollbarWidth = getScrollbarWidth();
            document.body.style.setProperty('--scrollbar-width', scrollbarWidth.toString() + 'px');
            search.classList.add('search--open');
            searchButton.setAttribute('aria-expanded', 'true');
            header.classList.add('elevate');
            body.classList.add('no-scroll');
            gsap.to(search, {
                duration: 0,
                y: 0,
                transformOrigin: 'top',
                ease: 'expo.inOut',
                onComplete: () => {
                    focusLock.on(search);
                },
            });

            search.addEventListener('keyup', escapeEvent);
        }
    };
})();